import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppParamType } from 'app/com/ibm/tw/commons/enums/global/appparam.type';
import { ShareService } from 'app/services';
import { Observable } from 'rxjs';
import { EventData, StatusService } from 'ui-components/common';
import { FavoriteViewForm } from './../../../../com/ibm/tw/commons/mvc/favorite.viewform';
import { AxthenticationService } from './../../../../services/axthentication.service';
import { TxnService } from './../../../../services/txn.service';
import { PageCodeService } from './../../../pagecode.service';
import { WebMenuItem } from './megamenu/webmenuitem';

@Component({
    standalone: false,
    selector: 'gib-favorite-popup',
    templateUrl: 'ccmhmanno.favorite.popup.component.html'
})
export class CcmhmannoFavoriteComponent implements OnInit {

    /**
     * 我的最愛
     */
    @Input() favoriteTaskList: WebMenuItem[] = [];

    /**
     * 顯示編輯我的最愛對話框
     */
    @Input() display: boolean = false;

    /**
     * popup於關閉時的Call Back
     */
    @Output() callback = new EventEmitter();

    /**
     * popup 的高度
     */
    height: number = 600

    /**
     * popup內容的高度
     */
    contentHeight: number = 450;

    constructor(
        private axthenticationService: AxthenticationService,
        private shareService: ShareService,
        private pageCodeService: PageCodeService,
        private statusService: StatusService, public txnService: TxnService) {
    }

    ngOnInit() {
        // console.log('CcmhmannoFavoriteComponent init...');
    }

    onClose() {
        this.callback.emit({});
    }

    /**
     * 要顯示前先依內容重新計算高度
     */
    onShow() {
        this.updateHeight();
    }

    /**
     * 重新計算對話框的高度
     */
    updateHeight() {
        this.height = (this.favoriteTaskList.length * 45) + 200;
        if (this.height < 300) {
            this.height = 300;
        }
        this.contentHeight = this.height - 150;

        if (this.contentHeight < 150) {
            this.contentHeight = 150;
        }
    }
    onHide() {
        this.callback.emit({});
    }

    /**
     * 移除單一個，我的最愛
     * @param event
     * @param item
     */
    removeItem(event: EventData, item: WebMenuItem) {
        // console.log('removeItem..' + JSON.stringify(item));
        if (!this.axthenticationService.isLoggedIn) {
            return;
        }

        let favoriteViewForm: FavoriteViewForm = new FavoriteViewForm();
        favoriteViewForm.taskIxd = item.taskIxd;
        favoriteViewForm.menuCategory = item.menuCategory;
        favoriteViewForm.areaType = item.areaType;
        this.statusService.show();

        let response: Observable<FavoriteViewForm> = this.pageCodeService.updateFavoriteTask(favoriteViewForm);
        response.subscribe(result => {
            //GIB-3801 設定 doErrorLogFlag 參數
            this.shareService.setAppParam(AppParamType.DOERRORLOG_FLAG, result.doErrorLogFlag);
            // 完成更新，需要將我的最愛清單重新設定
            if (typeof (result.errorMessage) !== 'undefined' && result.errorMessage !== '') {
                this.statusService.addMsg(result.errorMessage);
            } else {
                this.axthenticationService.favoriteTaskList = result.favoriteTaskList;
                this.favoriteTaskList = this.parseWebMenuItemLabel(result.favoriteTaskList);
                this.updateHeight();
            }
            this.statusService.hide();
        },
            err => {
                // GIB-3801 設定 doErrorLogFlag 參數
                if (err.doErrorLogFlag !== undefined) {
                    this.shareService.setAppParam(AppParamType.DOERRORLOG_FLAG, err.doErrorLogFlag);
                }
                this.statusService.hide();
                this.statusService.addMsg(this.txnService.transform('系統忙錄中，請稍後再試!', 'common00005531', null));
                // console.log('SystemError:' + err);
            });

    }

    /**
     * 額外處理web menu item.
     * @param webMenuItemArray
     */
    parseWebMenuItemLabel(webMenuItemArray: WebMenuItem[]) {
        let webMenuItemList: WebMenuItem[] = JSON.parse(JSON.stringify(webMenuItemArray));
        if ((webMenuItemList !== undefined) && webMenuItemList !== null) {
            for (let i = 0; i < webMenuItemList.length; i++) {
                let webMenuItem = webMenuItemList[i];
                if (webMenuItem.areaType !== this.axthenticationService.companyAreaType) {
                    // console.log('areaType=' + webMenuItem.areaType + ',company=' + this.axthenticationService.companyAreaType);
                    if (webMenuItem.areaType !== undefined) {
                        webMenuItem.name += '(' + this.parseAreaLabel(webMenuItem.areaType) + ')'
                    }
                }
            }
        }
        return webMenuItemList;
    }

    /**
     * 解析目前地區的table 名稱.
     * @param areaType
     */
    parseAreaLabel(areaType: string) {
        for (let j = 0; j < this.axthenticationService.userAreaOptions.length; j++) {
            let area = this.axthenticationService.userAreaOptions[j];
            // console.log('areaType=' + areaType + ',' + area.value + ',' + area.label);
            if (areaType === area.value) {
                return area.label;
            }
        }
    }

    /**
     * 儲存我的最愛清單
     */
    saveFavorite() {
        // console.log('saveFavorite......');
        if (!this.axthenticationService.isLoggedIn) {
            return;
        }

        let favoriteViewForm: FavoriteViewForm = new FavoriteViewForm();
        favoriteViewForm.favoriteTaskList = this.favoriteTaskList;
        this.statusService.show();
        let response: Observable<FavoriteViewForm> = this.pageCodeService.updateFavoriteTaskList(favoriteViewForm);
        response.subscribe(result => {
            // GIB-3801 設定 doErrorLogFlag 參數
            this.shareService.setAppParam(AppParamType.DOERRORLOG_FLAG, result.doErrorLogFlag);
            // 完成更新，需要將我的最愛清單重新設定
            if (typeof (result.errorMessage) !== 'undefined' && result.errorMessage !== '') {
                this.statusService.addMsg(result.errorMessage);
            } else {
                this.axthenticationService.favoriteTaskList = result.favoriteTaskList;
            }
            this.statusService.hide();
            this.callback.emit({});
        },
            err => {
                // GIB-3801 設定 doErrorLogFlag 參數
                if (err.doErrorLogFlag !== undefined) {
                    this.shareService.setAppParam(AppParamType.DOERRORLOG_FLAG, err.doErrorLogFlag);
                }
                this.statusService.hide();
                this.statusService.addMsg(this.txnService.transform('系統忙錄中，請稍後再試!', 'common00005531', null));
                this.callback.emit({});
                // console.log('SystemError:' + err);
            });
    }

}
